var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "add-appointment view" },
    [
      _vm.isE2EFlow && _vm.getFlowState === "REN_DETAILS"
        ? _c(
            "div",
            { staticClass: "view_top" },
            [
              _c("ma-navbar-stepper", {
                attrs: { numberOfStep: 3, textOfStep: _vm.$t("stepper.step3") },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "view_content" },
        [
          _c("transition", { attrs: { mode: "out-in" } }, [
            _vm.isE2EFlow && _vm.getFlowState === "REN_DETAILS"
              ? _c(
                  "div",
                  { staticClass: "view_content_markdown mg mg--b-7" },
                  [
                    _c("h1", { staticClass: "mg mg--b-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("appointment.appointmentContainer.title"))
                      ),
                    ]),
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("appointment.appointmentContainer.solution")
                        )
                      ),
                    ]),
                    _c("p", { staticClass: "text-medium mg mg--b-4 mg--t-2" }, [
                      _vm._v(
                        _vm._s(_vm.$t("appointment.appointmentContainer.text"))
                      ),
                    ]),
                    _c("div", { staticClass: "box-information" }, [
                      _c("div", { staticClass: "info-icon" }, [
                        _c("p", [_vm._v("¡")]),
                      ]),
                      _c("div", { staticClass: "info-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "appointment.appointmentContainer.wld.infoText"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("appointment.appointmentContainer.text2"))
                      ),
                    ]),
                    _c("div", {
                      staticClass: "confirm-sinister-info_calendar-wrapper",
                    }),
                    _c("ma-appointment-calendar", {
                      staticClass: "mg mg--b-7",
                      attrs: { availableDates: _vm.availableDates },
                      on: { clickDate: _vm.handleClickDate },
                    }),
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _vm.selectedDate
                          ? _c(
                              "p",
                              {
                                staticClass: "text-medium gray mg mg--b-4 left",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "appointment.appointmentContainer.text3"
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _c("ma-appointment-hours", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isHoursVisible,
                              expression: "isHoursVisible",
                            },
                          ],
                          staticClass: "mg mg--b-7",
                          attrs: {
                            availableHours: _vm.availableHours,
                            selectedHour: _vm.selectedHour.from,
                          },
                          on: { clickHour: _vm.handleClickHour },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.getFlowState === "REN_DETAILS_RDF"
              ? _c("div", { staticClass: "view_content_markdown mg mg--b-7" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("appointment.appointmentContainer.text4"))
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("appointment.appointmentContainer.text5"))
                    ),
                  ]),
                  _c("div", { staticClass: "box-information" }, [
                    _c("div", { staticClass: "info-icon" }, [
                      _c("p", [_vm._v("¡")]),
                    ]),
                    _c("div", { staticClass: "info-text" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "appointment.appointmentContainer.wld.infoText"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "confirm-sinister-info_calendar-wrapper" },
                    [
                      _c("ma-appointment-calendar", {
                        staticClass: "mg mg--b-7",
                        attrs: { availableDates: _vm.availableDates },
                        on: { clickDate: _vm.handleClickDate },
                      }),
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _vm.selectedDate
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "text-medium gray mg mg--b-4 left",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "appointment.appointmentContainer.text3"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _c("ma-appointment-hours", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isHoursVisible,
                                expression: "isHoursVisible",
                              },
                            ],
                            attrs: {
                              availableHours: _vm.availableHours,
                              selectedHour: _vm.selectedHour.from,
                            },
                            on: { clickHour: _vm.handleClickHour },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isWldFlow
              ? _c("div", { staticClass: "view_content_markdown mg mg--b-7" }, [
                  _c("h1", { staticClass: "mg mg--b-7" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("appointment.appointmentContainer.wld.title")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "box-information" }, [
                    _c("div", { staticClass: "info-icon" }, [
                      _c("p", [_vm._v("¡")]),
                    ]),
                    _c("div", { staticClass: "info-text" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "appointment.appointmentContainer.wld.infoText"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("p", { staticClass: "text-medium mg mg--b-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("appointment.appointmentContainer.wld.text")
                      )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "confirm-sinister-info_calendar-wrapper" },
                    [
                      _c("ma-appointment-calendar", {
                        staticClass: "mg mg--b-7",
                        attrs: { availableDates: _vm.availableDates },
                        on: { clickDate: _vm.handleClickDate },
                      }),
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _vm.selectedDate
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "text-medium gray mg mg--b-4 left",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "appointment.appointmentContainer.text3"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _c("ma-appointment-hours", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isHoursVisible,
                                expression: "isHoursVisible",
                              },
                            ],
                            attrs: {
                              availableHours: _vm.availableHours,
                              selectedHour: _vm.selectedHour.from,
                            },
                            on: { clickHour: _vm.handleClickHour },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm.isWldFlow
        ? _c(
            "div",
            { staticClass: "view_actions" },
            [
              _c("ma-actions-buttons", {
                attrs: {
                  handleButtonClick: _vm.handlePrimaryButtonClickWLD,
                  handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClickWLD,
                  title: _vm.$t(
                    "appointment.appointmentContainer.actions.wld.primary"
                  ),
                  titleWhiteBtn: _vm.$t(
                    "appointment.appointmentContainer.actions.wld.secondary"
                  ),
                  helperMainWhiteText: _vm.$t(
                    "appointment.appointmentContainer.actions.secondaryHelpText"
                  ),
                  mainBlueShouldBeDisabled: _vm.primaryButtonIsDisabled,
                  btnType: _vm.getBtnType,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getFlowState === "REN_DETAILS"
        ? _c(
            "div",
            { staticClass: "view_actions" },
            [
              _c(
                "ma-actions-buttons",
                {
                  attrs: {
                    handleButtonClick: _vm.handlePrimaryButtonClick,
                    handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
                    title: _vm.$t(
                      "appointment.appointmentContainer.actions.ren.primary"
                    ),
                    titleWhiteBtn: _vm.$t(
                      "appointment.appointmentContainer.actions.secondary"
                    ),
                    mainBlueShouldBeDisabled: _vm.primaryButtonIsDisabled,
                    btnType: _vm.getBtnType,
                  },
                },
                [
                  _vm.isE2EFlow
                    ? _vm._t("default", function () {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn mainWhite btnText",
                              on: { click: _vm.handleTertiaryButtonClick },
                            },
                            [
                              _c("p", { staticClass: "text-medium" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "appointment.appointmentContainer.actions.ren.tertiary"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getFlowState === "REN_DETAILS_RDF"
        ? _c(
            "div",
            { staticClass: "view_actions" },
            [
              _c("ma-actions-buttons", {
                attrs: {
                  handleButtonClick: _vm.handlePrimaryButtonClickRDF,
                  handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClickRDF,
                  title: _vm.$t(
                    "appointment.appointmentContainer.actions.primary"
                  ),
                  titleWhiteBtn: _vm.$t(
                    "appointment.appointmentContainer.actions.secondary"
                  ),
                  helperMainWhiteText: _vm.$t(
                    "appointment.appointmentContainer.actions.secondaryHelpText"
                  ),
                  mainBlueShouldBeDisabled: _vm.primaryButtonIsDisabled,
                  btnType: _vm.getBtnType,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "ma-modal",
        {
          ref: "modalAppointmentConfirmation",
          staticClass: "modal-confirmation",
          attrs: { type: "smallCenter", closeIsHidden: "" },
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c(
                "p",
                { staticClass: "headline-medium center gray mg mg--b-5" },
                [_vm._v(_vm._s(_vm.appointmentModalContent.title))]
              ),
              _c("p", { staticClass: "text-medium gray mg mg--b-5" }, [
                _vm._v(_vm._s(_vm.appointmentModalContent.description)),
              ]),
              _c("div", { staticClass: "container-btn-non-fixed" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn mainBlue",
                    on: { click: _vm.handleConfirmModalNextStep },
                  },
                  [
                    _c("p", { staticClass: "text-medium" }, [
                      _vm._v(_vm._s(_vm.appointmentModalContent.cta)),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }